/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aifeatureplanassistant3Inputs */

const en_aifeatureplanassistant3 = /** @type {(inputs: Aifeatureplanassistant3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan assistant in the app`)
};

const de_aifeatureplanassistant3 = /** @type {(inputs: Aifeatureplanassistant3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planungsassistent in der App`)
};

/**
* | output |
* | --- |
* | "Plan assistant in the app" |
*
* @param {Aifeatureplanassistant3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aifeatureplanassistant3 = /** @type {((inputs?: Aifeatureplanassistant3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aifeatureplanassistant3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aifeatureplanassistant3(inputs)
	return de_aifeatureplanassistant3(inputs)
});
export { aifeatureplanassistant3 as "aiFeaturePlanAssistant" }